import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

import PlaceholderImage from '@Images/placeholder.png';
import lazyImport from '@Utils/lazyImport';

const ReactImageGallery = lazyImport(() => import('react-image-gallery'));

interface GalleryImage {
  thumbnail: string;
  image: string;
}

export interface ImageGalleryProps {
  mainImage?: string;
  mainImageThumbnail?: string;
  images: GalleryImage[];
  mainImageAlt?: string;
}

const ImageGallery: FunctionComponent<ImageGalleryProps> = ({
  images = [],
  mainImage,
  mainImageAlt,
  mainImageThumbnail,
}) => {
  const mainImageUrl = mainImage || PlaceholderImage;
  const mainImageThumbnailUrl = mainImageThumbnail || PlaceholderImage;

  const items = [
    { original: mainImageUrl, thumbnail: mainImageThumbnailUrl, originalAlt: mainImageAlt },
    ...images.map(image => ({
      original: image.image,
      thumbnail: image.thumbnail,
    })),
  ];

  const handleOnClick = (
    isFullScreen: boolean,
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    handleEvent: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void,
  ) => {
    window.document.body.style.overflowY = isFullScreen ? 'initial' : 'hidden';
    handleEvent(event);
  };

  return (
    <ReactImageGallery
      items={items}
      showPlayButton={false}
      useBrowserFullscreen={false}
      showThumbnails={items.length > 1}
      lazyLoad={true}
      showNav={false}
      slideDuration={0}
      renderFullscreenButton={(
        onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void,
        isFullscreen: boolean,
      ) => {
        return (
          <button
            aria-label={mainImageAlt}
            onClick={event => handleOnClick(isFullscreen, event, onClick)}
            className={classNames('buttonZoom', isFullscreen && 'fullscreen')}
          />
        );
      }}
    />
  );
};

export default ImageGallery;
